export const UPDATE_PROCESS_STATEMENTS_SUCCESS = 'UPDATE_PROCESS_STATEMENTS_SUCCESS';

export const updateProcessStatementsSuccess = processStatements => ({
    type: UPDATE_PROCESS_STATEMENTS_SUCCESS,
    payload: { processStatements },
});
